import FullLayout from '@/layouts/full/FullLayout.vue';
import type { RouteRecordRaw } from 'vue-router';

// ────────────────────────────────────────────────────────────
// Relatório Municipal Consolidado
//
// Rota REAL (não só de permissão): o syncFrontendRoutes do login do Admin Master
// cadastra este path na tabela `routes`, e o backend verifica a permissão em
// /relatorio-municipal (migration 225).
// ────────────────────────────────────────────────────────────

export const relatorioMunicipalRoutes: RouteRecordRaw[] = [
  {
    path: '/relatorio-municipal',
    component: FullLayout,
    meta: { requiresAuth: true, title: 'Relatório Municipal' },
    children: [
      {
        path: '',
        name: 'RelatorioMunicipal',
        component: () => import('@/views/RelatorioMunicipal/RelatorioMunicipal.vue'),
        meta: {
          requiresAuth: true,
          title: 'Relatório Municipal',
          breadcrumb: 'Relatório Municipal',
        },
      },
    ],
  },
];

export default relatorioMunicipalRoutes;
